var timer;

export default function debounce(func, time = 100) {
  return function (event) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, time, event);
  };
}
